import {useQuery} from "@tanstack/react-query";
import {Asset, AssetsApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchAsset(assetId: string): Promise<Asset> {
    if (!assetId) {
        return;
    }

    return await new AssetsApi(getConfig()).getAsset({
        id: assetId,
    });
}

function assetQuery(assetId: string) {
    return {
        queryKey: [
            "asset",
            assetId,
        ],
        queryFn: () => fetchAsset(assetId),
        keepPreviousData: true,
        staleTime: 30 * 60000,
        refetchOnWindowFocus: false,
        enabled: Boolean(assetId),
    } as const;
}

export function useAsset(assetId: string) {
    // const queryClient = useQueryClient();
    return useQuery(assetQuery(assetId));
}

